import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: React.ReactElement<LucideIcon>;
  title: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'dashed';
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'dashed',
  className,
}: EmptyStateProps) {
  return (
    <Card
      className={cn(
        'shadow-sm',
        variant === 'dashed' ? 'border-2 border-dashed border-slate-200 bg-slate-50' : 'border-slate-200',
        className
      )}
    >
      <CardContent className="py-16 text-center">
        {React.cloneElement(icon, { className: 'h-12 w-12 text-slate-300 mx-auto mb-4' })}
        <p className="text-slate-500 font-medium">{title}</p>
        {description && <p className="text-sm text-slate-400 mt-1">{description}</p>}
        {action && <div className="mt-6">{action}</div>}
      </CardContent>
    </Card>
  );
}
